<template>
  <CForm ref="uploadimage">
    <Loading v-if="isLoading"></Loading>
    <div v-else>
      <CRow>
        <CCol lg="12"><br /></CCol>
      </CRow>
      <CRow>
        <CCol lg="6">
          <template v-if="userDocument.length === 0 || userDocument.ktp === null">
            <label>Insert KTP</label>
            <CInputFile
                ref="fileupload"
                name="ktp"
                label
                accept="image/*"
                invalid-feedback="Name should be filled"
                required
                @change="onFileChange($event, 'ktp')"
            />

            <CInput
                :type="'hidden'"
                required
                v-model="$v.uploadImageForm.ktp.$model"
                :is-valid="!$v.uploadImageForm.ktp.$invalid"
            ></CInput>
          </template>

          <CButton
            v-if="userDocument.length === 0 || userDocument.ktp === null"
            @click="submitForm($event, 'ktp')"
            :disabled="uploadImageForm.ktp === null"
            color="success"
          >
            <i class="fa fa-save"></i>
            Accept </CButton
          >&nbsp;
          <CButton v-if="userDocument.length === 0 || userDocument.ktp !== null" @click="removeImage('ktp')" color="danger">
            <i class="fa fa-remove"></i>
            Remove
          </CButton>

          <CRow>
            <CCol lg="6">
              <div>Preview KTP :</div>
              <br />
              <CCard v-if="userDocument.length > 0 && (userDocument.ktp === null && uploadImageForm.ktp !== null)">
                <CImg :src="uploadImageForm.ktp" :thumbnail="true" />
              </CCard>
              <CCard v-else-if="(userDocument.length > 0 && userDocument.ktp !== null)">
                <div @click="previewForm" style="cursor: pointer">
                  <CImg :src="'https://storage.googleapis.com/isikulkas/' + userDocument.ktp +'?r=' + unixTime" :thumbnail="true"/>
                </div>
              </CCard>
              <CCard v-else>
                <CCardBody>
                  <CRow>
                    <div>
                      <CCol sm="12">No image</CCol>
                    </div>
                  </CRow>
                </CCardBody>
              </CCard>
            </CCol>
          </CRow>
        </CCol>
        <CCol lg="6">
        <template v-if="userDocument.length === 0 ||userDocument.selfie === null">
          <label>Insert Selfie</label>
          <CInputFile
            ref="fileupload2"
            name="selfie"
            label
            accept="image/*"
            invalid-feedback="Name should be filled"
            required
            @change="onFileChange($event, 'selfie')"
          />

          <CInput
            :type="'hidden'"
            required
            v-model="$v.uploadImageForm.selfie.$model"
            :is-valid="!$v.uploadImageForm.selfie.$invalid"
          ></CInput>
        </template>
          <CButton
            v-if="userDocument.length === 0 ||userDocument.selfie === null"
            @click="submitForm($event, 'selfie')"
            :disabled="uploadImageForm.selfie === null "
            color="success"
          >
            <i class="fa fa-save"></i>
            Accept </CButton
          >&nbsp;
          <CButton v-if="userDocument.length === 0 ||userDocument.selfie !== null" @click="removeImage('selfie')" color="danger">
            <i class="fa fa-remove"></i>
            Remove
          </CButton>

          <CRow>
            <CCol lg="6">
              <div>Preview Selfie :</div>
              <br />
              <CCard
                v-if="userDocument.length > 0 && (userDocument.selfie === null && uploadImageForm.selfie !== null)"
              >
                <CImg :src="uploadImageForm.selfie" :thumbnail="true" />
              </CCard>
              <CCard v-else-if="(userDocument.length > 0 && userDocument.selfie !== null)">
                <div @click="previewForm" style="cursor: pointer">
                  <CImg :src="'https://storage.googleapis.com/isikulkas/' + userDocument.selfie +'?r=' + unixTime" :thumbnail="true"/>
                </div>
              </CCard>
              <CCard v-else>
                <CCardBody>
                  <CRow>
                    <div>
                      <CCol sm="12">No image</CCol>
                    </div>
                  </CRow>
                </CCardBody>
              </CCard>
            </CCol>
          </CRow>
        </CCol>
      </CRow>
    </div>
  </CForm>
</template>

<script>
import Loading from "@/templates/Loading";
import GlobalTable from "@/templates/Table";
import tableInterfaces from "@/templates/_table_interfaces.js";
import { required } from "vuelidate/lib/validators";

export default {
  name: "UserDocument",
  components: { GlobalTable, Loading },
  data() {
    return {
      items: [],
      uploadImageForm: tableInterfaces.user_document,
      isLoading: false,
      image_ktp: null,
      image_selfie: null,
      activeTab: 0,
      preview: false,
      unixTime: Math.floor(Math.random() * (0 - 9999999999 + 1)) + 0,
    };
  },
  props: {
    userDocument: {
      type: [Array, Object],
      default: () => [],
    },
    userStatus: {
      type: String,
      default: null,
    },
    userCode: {
      type: String,
      default: null,
    },
  },
  validations() {
    if (this.uploadImageForm.ktp !== null) {
      return {
        uploadImageForm: {
          ktp: { required },
          selfie: {},
        },
      };
    } else {
      return {
        uploadImageForm: {
          ktp: {},
          selfie: { required },
        },
      };
    }
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },

  methods: {
    init: function () {
      this.$emit('update:userCode', this.userCode);
      this.unixTime = Math.floor(Math.random() * (0 - 9999999999 + 1)) + 0;
    },
    back: function () {
      this.$router.go(-1);
    },
    previewForm: function () {
      this.preview = true;
      this.isEdit = false;
      this.addButton = false;
    },
    submitForm: function (evt, flag = "") {
      evt.preventDefault();
      if (confirm("Apakah anda ingin merubah Data ini ?")) {
        this.isLoading = true;
        this.uploadImageForm.user_code = this.userCode;
        this.uploadImageForm.flag = flag;
        this.axios
          .put("console/users/update-image", this.uploadImageForm)
          .then((response) => {
            this.userDocument[flag] = response.data.images;
            this.showInfoNotification({
              title: "Ubah Product Image",
              message: response.data.message,
            });
          })
          .catch((error) => {
            this.expired(error, "Ubah Product Image");
          })
          .finally(() => {
            this.isLoading = false;
            let route = this.$route.path.split("/");
            this.init(route[4]);
          });
      }
    },
    onFileChange: function(e, flag) {
      if (flag === "ktp") {
        this.uploadImageForm.selfie = null;
        this.$refs.fileupload.value = null;
      } else {
        this.uploadImageForm.ktp = null;
        this.$refs.fileupload2.value = null;
      }
      this.createImage(e[0], flag);
    },
    createImage: function(file, flag) {
      var image = new Image();
      var reader = new FileReader();
      var vm = this;
      reader.onload = (e) => {
        vm.image = e.target.result;
        this.uploadImageForm[flag] = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    removeImage: function (flag) {
      if (confirm("Apakah anda ingin merubah Data ini ?")) {
        this.isLoading = true;
        var remove = {
          [flag]: this.userDocument[flag],
          user_code: this.userCode,
          flag: flag,
        };

        this.axios
          .put("console/users/remove-image", remove)
          .then((response) => {
                this.$refs.uploadimage.reset();
                this.$refs.fileupload.value = null;
                this.$refs.fileupload2.value = null;
                this.uploadImageForm[flag] = null;   
                this.userDocument[flag] = null;
          })
          .catch((error) => {
            this.expired(error, "Ubah Product Issue");
          })
          .finally(() => {
            this.isLoading = false;
            this.$router.go(0);
            // let route = this.$route.path.split("/");
            // this.init(route[4]);
          });
      }
      //console.log(this.products.images);
    }
  },
  mounted() {
    this.init();
  },
};
</script>

<style>
.ui.selection.dropdown.error {
  border-color: #e55353;
}
.ui.selection.dropdown {
  border-color: #2eb85c;
}
.ui.selection.dropdown.disabled {
  background-color: #d8dbe0;
  opacity: 0.8;
}
</style>